import React from 'react';
import { ServiceLandingHero } from '../components/ServiceLandingHero';
import { ArrowRightIcon } from 'lucide-react';
import { commercialSeasonalPage } from '../data/commercialSeasonal';
export function CommercialSeasonalServicesPage() {
  const {
    hero,
    winter,
    support,
    related
  } = commercialSeasonalPage;
  return <>
      {/* Service landing hero */}
      <ServiceLandingHero id="top" eyebrow={hero.eyebrow} title={hero.title} intro={hero.intro} image={hero.image} alt={hero.alt} tone="ivory" data-id="element-530" data-mp="95ken6fl987l" />

      {/* Dominant winter service */}
      <section id="winter-care" aria-labelledby="winter-care-title" className="section-y bg-olive text-ivory" data-id="element-531" data-mp="n2h536rsonny">
        <div className="site-container grid gap-10 lg:grid-cols-12 lg:gap-14" data-id="element-532" data-mp="s1ai6y366cnl">
          <div className="lg:col-span-5" data-id="element-533" data-mp="1frwczno5y0fn">
            <p className="eyebrow text-ivory/70" data-id="element-534" data-mp="1fq36q9hgpi86">{winter.eyebrow}</p>
            <h2 id="winter-care-title" className="section-title mt-4" data-id="element-535" data-mp="1kjo88bi9kuc4">{winter.title}</h2>
            <p className="mt-5 max-w-[480px] text-[16px] leading-relaxed text-ivory/80 sm:text-[17px]" data-id="element-536" data-mp="383g9t5ojfoo7">{winter.text}</p>
          </div>
          <ul aria-label="Winter services" className="grid border-t border-ivory/25 sm:grid-cols-2 sm:gap-x-10 lg:col-span-7 lg:self-end" data-id="element-537" data-mp="3354z6sqf5a4x">
            {winter.items.map(item => <li key={item} className="flex min-h-[64px] items-center border-b border-ivory/20 py-4 font-display text-[23px] font-medium leading-snug lg:text-[26px]" data-id="element-538" data-mp="3c25iwm2jmk21">
                {item}
              </li>)}
          </ul>
        </div>
      </section>

      {/* Paved areas & active sites */}
      <section aria-labelledby="active-sites-title" className="section-y bg-ivory" data-id="element-539" data-mp="3vtam9m4y3b7x">
        <div className="site-container" data-id="element-540" data-mp="25eryz6fbtmy0">
          <h2 id="active-sites-title" className="section-title max-w-[720px] text-charcoal" data-id="element-541" data-mp="25hmfwnz4spmo">{support.title}</h2>
          <div className="mt-10 grid border-t border-charcoal/15 md:grid-cols-2 lg:mt-12" data-id="element-542" data-mp="21gb17dhspot9">
            {support.groups.map((group, i) => <section key={group.id} id={group.id} aria-labelledby={`${group.id}-title`} className={`py-8 lg:py-10 ${i === 0 ? 'border-b border-charcoal/15 md:border-b-0 md:border-r md:pr-10 lg:pr-14' : 'md:pl-10 lg:pl-14'}`} data-id="element-543" data-mp="9blufv3ao4th" data-mpi={i}>
                <h3 id={`${group.id}-title`} className="font-display text-[28px] font-medium leading-[1.12] text-charcoal lg:text-[34px]" data-id="element-544" data-mp="sarbwm8tcc9b">
                  {group.title}
                </h3>
                <p className="mt-3 max-w-[480px] text-[16px] leading-relaxed text-charcoal/75" data-id="element-545" data-mp="120j6vhktr7eb">{group.text}</p>
                <ul className="mt-6 border-t border-charcoal/10" data-id="element-546" data-mp="16y2n2n131u8w">
                  {group.items.map(item => <li key={item} className="flex min-h-[48px] items-start gap-3 border-b border-charcoal/10 py-3 text-[16px] leading-[1.5] text-charcoal/85" data-id="element-547" data-mp="1azee8wzlunj7">
                      <span className="mt-[10px] h-1 w-1 shrink-0 rounded-full bg-moss" aria-hidden="true" data-id="element-548" data-mp="2milg9r5hu891" />
                      <span data-id="element-549" data-mp="2hktpj0gl4s6f">{item}</span>
                    </li>)}
                </ul>
              </section>)}
          </div>
        </div>
      </section>

      {/* Related growing-season care */}
      <section aria-labelledby="related-care-title" className="border-t border-charcoal/10 bg-stone/70" data-id="element-550" data-mp="3a97obifhzsj1">
        <div className="site-container flex flex-col gap-4 py-10 md:py-12 lg:flex-row lg:items-center lg:justify-between lg:gap-12" data-id="element-551" data-mp="35g4quz7lnyxk">
          <div className="max-w-[760px]" data-id="element-552" data-mp="1sw27gcm6qhe">
            <h2 id="related-care-title" className="font-display text-[26px] font-medium leading-[1.15] text-charcoal sm:text-[30px]" data-id="element-553" data-mp="1txlu97p4laq">
              {related.title}
            </h2>
            <p className="mt-2 text-[16px] leading-relaxed text-charcoal/75" data-id="element-554" data-mp="3dpajq9xxrfkq">{related.text}</p>
          </div>
          <a href={related.link.href} className="focus-ring group inline-flex min-h-[44px] shrink-0 items-center gap-2 text-[15px] font-medium text-olive" data-id="element-555" data-mp="3hs6uxfl5c9en">
            <span className="border-b border-olive/35 pb-0.5 transition-colors duration-150 group-hover:border-olive" data-id="element-556" data-mp="38pnwd7oe8iy7">
              {related.link.label}
            </span>
            <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-0.5" strokeWidth={1.5} aria-hidden="true" data-id="element-557" data-mp="59qr9d53a16q" />
          </a>
        </div>
      </section>
    </>;
}